import { ApiError, normalizeDrfError } from "./errors";

export type ErrorNormalizer = (
  payload: unknown,
  status: number,
) => ReturnType<typeof normalizeDrfError>;

/**
 * Read a fetch Response body as JSON (when content-type includes application/json)
 * or as plain text otherwise.  Parse failures are caught and return null.
 */
export async function readBody(res: Response): Promise<unknown> {
  const ct = res.headers.get("content-type") ?? "";
  if (ct.includes("application/json")) {
    return await res.json().catch(() => null);
  }
  return await res.text().catch(() => null);
}

/**
 * If the response is not ok, normalize the body via the provided error normalizer
 * (default `normalizeDrfError`) and throw an ApiError. Otherwise returns without
 * throwing. `body` is the already-read body from `readBody()`.
 */
export function throwIfError(
  res: Response,
  body: unknown,
  normalize: ErrorNormalizer = normalizeDrfError,
): void {
  if (!res.ok) {
    const { message, code, fieldErrors, missingRequiredFields } = normalize(body, res.status);
    throw new ApiError({ status: res.status, message, code, fieldErrors, missingRequiredFields });
  }
}
